import React from "react";

interface GeneralInterpretationProps {
  interpretation: string[] | string;
}

const GeneralInterpretation: React.FC<GeneralInterpretationProps> = ({
  interpretation,
}) => {
  if (
    !interpretation ||
    (Array.isArray(interpretation) && interpretation.length === 0)
  ) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="mb-4 text-lg font-semibold text-navy-700 dark:text-white">
        Interpretación General
      </h3>
      <div className="rounded-lg bg-gray-50 p-4">
        {Array.isArray(interpretation) ? (
          <ul className="list-inside list-disc space-y-3 text-gray-700 dark:text-gray-400">
            {interpretation.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-700 dark:text-gray-400">{interpretation}</p>
        )}
      </div>
    </div>
  );
};

export default GeneralInterpretation;
